<div *ngIf="loading" class="spinner" style="padding-top: 0;min-height: 0" >
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

  <div *ngIf="!loading">
    <h1 mat-dialog-title >{{data.title}}</h1>
    <mat-card-content >
      <form [formGroup]="equipoForm">
  
        <div style="display: flex;justify-content: space-around;flex-wrap: wrap">
  
          <div style="flex-direction: column;display: flex">
            <h4 style="font-weight: bold">Equipo</h4>
            
                  <mat-form-field appearance="outline">
                    <mat-label>Equipo</mat-label>
                    <input type="text"
                           placeholder="Elige un equipo"
                           matInput
                           required
                           formControlName="nombre"
                           [matAutocomplete]="auto"
                    >
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChangedEquipo($event)">
                      <mat-option *ngFor="let option of filteredOptions | async" [value]="option" >
                        {{option}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>

                  <mat-form-field *ngIf="equipoForm.get(['nombre'])?.value !== '' " appearance="outline">
                    <mat-label>Marca</mat-label>
                    <input type="text"
                           placeholder="Elige una marca"
                           matInput
                           required
                           formControlName="marca"
                           [matAutocomplete]="autoMarca"
                    >
                    <mat-autocomplete #autoMarca="matAutocomplete" (optionSelected)="onSelectionChangedMarca($event)">
                      <mat-option *ngFor="let option of filteredOptionsMarca | async" [value]="option" >
                        {{option}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>

                  <mat-form-field *ngIf="equipoForm.get(['marca'])?.value !== '' " appearance="outline">
                    <mat-label>Modelo</mat-label>
                    <input type="text"
                           placeholder="Elige un modelo"
                           matInput
                           required
                           formControlName="modelo"
                           [matAutocomplete]="autoModelo"
                    >
                    <mat-autocomplete #autoModelo="matAutocomplete">
                      <mat-option *ngFor="let option of filteredOptionsModelo | async" [value]="option" >
                        {{option}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
        
  
  <!--           <mat-form-field appearance="outline" >
              <mat-label>Nombre</mat-label>
              <input matInput placeholder="Nombre" formControlName="nombre" name="nombre" required>
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label>Categoría</mat-label>
              <input matInput placeholder="Categoría"formControlName="categoria" name="categoria" required>
            </mat-form-field>
  
            <mat-form-field appearance="outline" >
              <mat-label>Marca</mat-label>
              <input matInput placeholder="Marca" formControlName="marca" name="marca" required>
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label>Talla</mat-label>
              <input matInput placeholder="Talla"formControlName="talla" name="talla" required>
            </mat-form-field>
  
            <mat-form-field appearance="outline" >
              <mat-label>Modelo</mat-label>
              <input matInput placeholder="Modelo" formControlName="modelo" name="modelo" required>
            </mat-form-field> -->
  
            <mat-form-field appearance="outline">
              <mat-label>Valoración</mat-label>
              <input matInput placeholder="Valoración"formControlName="valoracion" name="valoracion" required type="number">
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label>Observaciones</mat-label>
              <textarea matInput placeholder="Observaciones" formControlName="observaciones" name="observaciones" cols="40" rows="5" ></textarea>
            </mat-form-field>
          </div>
  
          <div style="flex-direction: column;display: flex" >
            <h4 style="font-weight: bold">Factura</h4>
  
            <mat-form-field appearance="outline" >
              <mat-label>Razón Social</mat-label>
              <input matInput placeholder="Razón Social" formControlName="razonSocial" name="razonSocial" required>
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label>RUC</mat-label>
              <input matInput placeholder="RUC"formControlName="ruc" name="ruc" required>
            </mat-form-field>
  
            <mat-form-field appearance="outline" >
              <mat-label>Número de Factura</mat-label>
              <input matInput placeholder="Número de Factura" formControlName="numFactura" name="numFactura" required>
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label>Costo</mat-label>
              <input matInput placeholder="Costo"formControlName="costo" name="costo" required type="number">
            </mat-form-field>
          </div>
  
        </div>
  
        <mat-dialog-actions align="center">
          <button mat-raised-button mat-dialog-close>Cancelar</button>
          <button mat-raised-button style="background-color: #e95a1a;color: white" *ngIf="this.data.estado==1" (click)="updateEquipo()">{{data.title}}</button>
          <button mat-raised-button style="background-color: #e95a1a;color: white" *ngIf="this.data.estado==2" (click)="createEquipo()">{{data.title}}</button>
        </mat-dialog-actions>
  
      </form>
    </mat-card-content>
  </div>